import React, { useState, useEffect } from 'react';
import Modal from '../common/Modal';
import {
  getBatchAddresses,
  sendBatchDeliveries,
} from './constants/mailerConstants';
import Icon from '../common/Icon';
import { sortByAlpha } from '../../helpers/sorters';
import LinkedMailerInfo from './LinkedMailerInfo';

const SendBatchMailerModal = (props) => {
  const { filters, mailers, viewMailSend, setViewMailSend } = props;
  const sortedMailers = sortByAlpha(mailers, 'name');
  const [selectedMailer, setSelectedMailer] = useState(null);
  const [disableSend, setDisableSend] = useState(true);
  const [mailCount, setMailCount] = useState({ send: null, fail: null });
  const [isFetching, setIsFetching] = useState(false);
  // TODO: make error text appear in modal, along with dropdown...
  const [errorText, setErrorText] = useState('');

  useEffect(() => {
    setIsFetching(false);
  }, [mailCount]);

  const handleMailerClick = async (e) => {
    let mailer = mailers.find((m) => m.id == e.target.id);
    setSelectedMailer(mailer);
    setErrorText('');
    let noMail = true;

    setIsFetching(true);
    let countData = await getBatchAddresses(mailer, filters);
    if (countData.ok && countData.data.emails_to_send) {
      const { emails_to_send, emails_not_found } = countData.data;
      setMailCount({ send: emails_to_send, fail: emails_not_found });
      noMail = !emails_to_send;
    }

    noMail ? setDisableSend(true) : setDisableSend(false);
  };

  const handleModalClose = () => {
    setViewMailSend(false);
    setSelectedMailer(null);
    setDisableSend(true);
    setMailCount({ send: null, fail: null });
  };

  return (
    <Modal
      show={viewMailSend}
      onClose={handleModalClose}
      title='send-mailer-modal'
    >
      <header>
        <h3>Send Batch Emails</h3>
      </header>

      <div className='send-mailer-content'>
        <div className='mailer-list-wrapper'>
          <h4>Select an email below to send:</h4>
          <ol className='mailer-list'>
            {mailers.length ? (
              sortedMailers.map((mailer) => {
                return (
                  <li
                    key={mailer.id}
                    className={
                      selectedMailer && mailer.id == selectedMailer.id
                        ? `mailer-${mailer.id} selected`
                        : `mailer-${mailer.id}`
                    }
                    id={mailer.id}
                    onClick={handleMailerClick}
                  >
                    {mailer.detected_forms?.length && (
                      <>
                        <Icon
                          icon='link'
                          title='Mailer utilizes related forms'
                        />
                        &nbsp;
                      </>
                    )}
                    {mailer.name}
                  </li>
                );
              })
            ) : (
              <li className='empty'>Create a mailer first!</li>
            )}
          </ol>
        </div>

        {selectedMailer && (
          <div className='mail-send flex'>
            <div className='mail-count'>
              <h3>Emails to Send:</h3>
              {!isFetching && <p>{mailCount.send}</p>}
            </div>

            <div className='mail-fail'>
              <h3>Addresses Not Found: </h3>
              {!isFetching && <p>{mailCount.fail}</p>}
            </div>
            {isFetching ? (
              <button className='batch-mail-btn' disabled>
                Send Email(s)
              </button>
            ) : (
              <button
                className='batch-mail-btn'
                disabled={disableSend}
                onClick={(e) => {
                  e.target.blur();
                  sendBatchDeliveries(
                    selectedMailer,
                    mailCount.send,
                    filters,
                    handleModalClose
                  );
                }}
              >
                Send Email(s)
              </button>
            )}
          </div>
        )}
      </div>
      {selectedMailer?.detected_forms?.length > 0 && (
        <LinkedMailerInfo
          batch={true}
          detectedForms={selectedMailer.detected_forms}
        />
      )}
    </Modal>
  );
};

export default SendBatchMailerModal;
